export const STATE_ORDER = ["iscrizione_aperta", "iscrizione_chiusa", "in_corso", "terminata"];

export const STATE_LABELS = {
  iscrizione_aperta: "Iscrizioni aperte",
  iscrizione_chiusa: "Iscrizioni chiuse",
  in_corso: "In corso",
  terminata: "Terminata",
};

const STATE_STYLE = {
  iscrizione_aperta: "text-green-400 border-green-500/40 bg-green-500/5",
  iscrizione_chiusa: "text-amber-400 border-amber-500/40 bg-amber-500/5",
  in_corso: "text-cyan-400 border-cyan-500/40 bg-cyan-500/5",
  terminata: "text-zinc-400 border-zinc-600 bg-zinc-800/40",
};

export function StateBadge({ state, testid }) {
  if (!state) return null;
  const s = STATE_STYLE[state] || "text-zinc-400 border-zinc-600";
  return (
    <span data-testid={testid}
      className={`inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider border px-2.5 py-1 rounded-full ${s}`}>
      {STATE_LABELS[state] || state}
    </span>
  );
}
